import { useState } from 'react';
import { ClickAwayListener } from '@monorepo/nova-ui';
import { useLocalStorage } from '@monorepo/react-hooks';
import { CartData, IsLoggedInKey } from '@monorepo/types';
import { HeaderMenuLink } from '@monorepo/types';
import { NotificationsCenter } from '../../notifications-center';
import { BalanceButton } from './balance-button';
import { CartButton } from './cart-button';
import { DiscordButton, LanguageSelector } from './components';
import { LogInButton } from './log-in-button';
import { Logo } from './logo';
import { MenuDesktop } from './menu-desktop';
import { MenuMobile } from './menu-mobile';
import { NewOrderButton } from './new-order-button';
import { ProfileMenu } from './profile-menu';
import {
  StyledHeaderContent,
  StyledHeaderDesktop,
  StyledIconButtonsGroup,
  StyledLeftSection,
  StyledRightSection,
} from './styles/layout-header-desktop.styled';
import { StyledMenuDesktopWrapper } from './styles/menu-desktop-wrapper.styled';
import { StyledMenuMobileWrapper } from './styles/menu-mobile-wrapper.styled';
import { SubMenuDesktop } from './submenu-desktop';
import { YoutubeLive } from './youtube-live';

/* For Desktop */
const LayoutHeader = ({
  cartData,
  isTransparent,
  userId,
}: {
  cartData: CartData;
  isTransparent: boolean;
  userId?: string;
}) => {
  const { storedValue: isUserLoggedIn } = useLocalStorage(IsLoggedInKey, false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState<HeaderMenuLink | null>(null);

  const handleCloseSubMenu = (event?: MouseEvent | TouchEvent) => {
    if (event) {
      const target = event.target as HTMLElement;
      if (target?.closest('.menu-desktop-button')) {
        return;
      }
    }

    setIsSubMenuOpen(false);
    setActiveMenu(null);
  };

  return (
    <>
      <StyledHeaderDesktop>
        <StyledHeaderContent
          className="header--desktop"
          isTransparent={isTransparent}
        >
          <StyledLeftSection>
            <StyledMenuMobileWrapper>
              <MenuMobile userId={userId} />
            </StyledMenuMobileWrapper>
            <Logo />
            <DiscordButton />
            <YoutubeLive />
          </StyledLeftSection>

          <StyledMenuDesktopWrapper>
            <MenuDesktop
              isSubMenuOpen={isSubMenuOpen}
              setIsSubMenuOpen={setIsSubMenuOpen}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              isTransparent={isTransparent}
            />
          </StyledMenuDesktopWrapper>

          <StyledRightSection>
            {isUserLoggedIn ? (
              <NewOrderButton cartData={cartData} />
            ) : (
              <LogInButton />
            )}
            <StyledIconButtonsGroup>
              {isUserLoggedIn && (
                <>
                  <BalanceButton userId={userId} />
                  <CartButton cartData={cartData} />
                  <NotificationsCenter />
                </>
              )}
              <ProfileMenu userId={userId} />
              <LanguageSelector />
            </StyledIconButtonsGroup>
          </StyledRightSection>
        </StyledHeaderContent>
      </StyledHeaderDesktop>
      {isSubMenuOpen && (
        <ClickAwayListener onClickAway={handleCloseSubMenu}>
          <SubMenuDesktop
            activeMenu={activeMenu}
            handleCloseSubMenu={handleCloseSubMenu}
          />
        </ClickAwayListener>
      )}
    </>
  );
};

export { LayoutHeader };
